import { useMemo } from 'react';
import { useRubricCheckOwnership } from '@internal/backstage-plugin-bidone';

// Rubric check ids currently owned by an active campaign. A check belongs to
// exactly one of the rubric or a single campaign at a time, so the scorecards
// UI hides these until the campaign ends. While the ownership map is loading
// (or if it fails) the set is empty and all checks show — scorecards must not
// break when the campaigns backend is unavailable.
export const useCampaignOwnedCheckIds = (): Set<string> => {
  const { data } = useRubricCheckOwnership();
  return useMemo(
    () => new Set((data ?? []).map(o => o.rubricCheckId)),
    [data],
  );
};
